import React, { useState, useEffect } from "react";
import axios from "axios";
import PrescriptionHistory from "./PrescriptionHistory";
import Navbar from "./Navbar";
import { useNavigate, useLocation } from "react-router-dom";

const PrescriptionDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [prescriptions, setPrescriptions] = useState([]);
  const [filteredPrescriptions, setFilteredPrescriptions] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPrescriptions = async () => {
    const patient_id = location.state?.student_id;
    if (!patient_id) {
      setError("Child ID is missing.");
      setIsLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/prescriptions",
        JSON.stringify({ patient_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data.data) {
        setPrescriptions(response.data.data);
        setFilteredPrescriptions(response.data.data);
      } else {
        setError("No prescriptions found.");
      }
    } catch (err) {
      console.error("Error fetching prescriptions:", err);
      setError("Failed to fetch prescriptions. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPrescriptions();
  }, []);

  const handleBack = () => navigate(-1);

  const handleDateChange = (e) => {
    const date = e.target.value;
    setSelectedDate(date);
    if (!date) {
      setFilteredPrescriptions(prescriptions);
      return;
    }
    const filtered = prescriptions.filter((p) => p.date.startsWith(date));
    setFilteredPrescriptions(filtered);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-100 to-teal-100">
      <div className="fixed w-full z-50 top-0 left-0 right-0 shadow-md bg-white">
        <Navbar />
      </div>

      <div className="pt-28 px-4 sm:px-8 max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-emerald-800 mb-6 text-center">
          Child Prescription Overview
        </h2>

        <div className="mb-6 flex justify-center">
          <input
            type="date"
            value={selectedDate}
            onChange={handleDateChange}
            className="rounded-lg border border-emerald-400 px-4 py-2 shadow-md text-emerald-800 focus:outline-none focus:ring-2 focus:ring-emerald-300"
          />
        </div>

        {isLoading ? (
          <div className="text-center text-emerald-600 text-lg font-medium py-10">
            Loading prescriptions...
          </div>
        ) : error ? (
          <div className="text-center text-red-600 text-lg font-medium py-10">
            {error}
          </div>
        ) : (
          <PrescriptionHistory
            prescriptions={filteredPrescriptions}
            selectedDate={selectedDate}
            onDateChange={handleDateChange}
            onBackClick={handleBack}
          />
        )}
      </div>
    </div>
  );
};

export default PrescriptionDashboard;
